module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "app-aside hidden-xs bg-black hidden-print ",
    class: {
      'off-screen': _vm.menuOpen
    },
    attrs: {
      "id": "aside"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "aside-wrap"
  }, [_c('div', {
    staticClass: "navi-wrap"
  }, [_c('nav', {
    staticClass: "navi clearfix",
    attrs: {
      "ui-nav": ""
    }
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "m-t"
  }, [(!_vm.ACL.check('coordES', _vm.currentUser.id)) ? _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-windows icon text-primary"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])]) : _vm._e()], 1), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('menu-title', [_vm._v("Remoção")]) : _vm._e(), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'callcenter.main'
      },
      "label": "Callcenter",
      "icon": "fa-headphones",
      "icon-color-class": "text-info",
      "show": _vm.ACL.check('restrito_visitante', _vm.currentUser.id)
    }
  }), _vm._v(" "), _c('menu-title', [_vm._v("Apps")]), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'arrematantes'
      },
      "label": "Arrematantes",
      "icon": "fa-users",
      "icon-color-class": "text-info",
      "show": _vm.ACL.check('restrito_visitante', _vm.currentUser.id)
    }
  }), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'comitentes'
      },
      "label": "Comitentes",
      "icon": "fa-briefcase",
      "icon-color-class": "text-success",
      "show": _vm.ACL.check('restrito_visitante', _vm.currentUser.id)
    }
  }), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'documentos'
      },
      "label": "Documentos",
      "icon": "icon-docs",
      "show": _vm.ACL.check('restrito_visitante', _vm.currentUser.id)
    }
  }), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('MenuAdminSite') : _vm._e(), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id) && _vm.ACL.check('acesso_menu_configuracoes', _vm.currentUser.id)) ? _c('MenuConfiguracoes') : _vm._e(), _vm._v(" "), (_vm.ACL.check('visualizar_leilao', _vm.currentUser.id)) ? _c('MenuLeilao') : _vm._e(), _vm._v(" "), (_vm.podeAcessarGrvs) ? _c('menu-title', [_vm._v("GRV")]) : _vm._e(), _vm._v(" "), (!_vm.ACL.check('coordES', _vm.currentUser.id) && _vm.ACL.checaAcessoContrato(_vm.ID_CONTRATO_DETRO, _vm.currentUser.id)) ? _c('MenuPoliciaCivil') : _vm._e(), _vm._v(" "), (_vm.ACL.checaAcessoContrato(_vm.ID_CONTRATO_DETRAN_VILA_VELHA_ES, _vm.currentUser.id) || _vm.ACL.checaAcessoContrato(_vm.ID_CONTRATO_DETRAN_CACHOEIRO_ES, _vm.currentUser.id)) ? _c('MenuEspiritoSanto') : _vm._e(), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'grv'
      },
      "label": "GRVs Detro-RJ",
      "icon": "fa-file-text-o",
      "icon-color-class": "text-info",
      "show": _vm.ACL.check('restrito_visitante', _vm.currentUser.id) && _vm.ACL.checaAcessoContrato(_vm.ID_CONTRATO_DETRO, _vm.currentUser.id)
    }
  }), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'grv',
        query: {
          tipoGrv: _vm.GRV_PREFEITURA
        }
      },
      "label": "GRVs Prefeitura Barra do Piraí",
      "icon": "fa-file-text-o",
      "show": _vm.ACL.checaAcessoContrato(_vm.ID_CONTRATO_PREFEITURA, _vm.currentUser.id)
    }
  }), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'grv',
        query: {
          tipoGrv: _vm.GRV_CAMPOS_DOS_GOYTACAZES
        }
      },
      "label": "GRVs Campos dos Goytacazes",
      "icon": "fa-file-text-o",
      "icon-color-class": "text-grey",
      "show": _vm.ACL.check('restrito_visitante', _vm.currentUser.id) && _vm.ACL.checaAcessoContrato(_vm.ID_CONTRATO_CAMPOS_DOS_GOYTACAZES, _vm.currentUser.id)
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "line dk hidden-folded"
  }), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'localizacao-veiculo'
      },
      "label": "Localização de Veículo",
      "icon": "fa-anchor",
      "icon-color-class": "text-info",
      "show": _vm.ACL.check('acesso_menu_localizacao', _vm.currentUser.id) && (!_vm.ACL.check('coordES', _vm.currentUser.id))
    }
  }), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'transferencia-patio'
      },
      "label": "Transferência de Pátio",
      "icon": "fa-car",
      "icon-color-class": "text-info",
      "show": _vm.ACL.check('acesso_menu_transferencia', _vm.currentUser.id) && (!_vm.ACL.check('coordES', _vm.currentUser.id))
    }
  }), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'cobranca'
      },
      "label": "Cobranças",
      "icon": "fa-money",
      "icon-color-class": "text-success",
      "show": _vm.ACL.check('restrito_visitante', _vm.currentUser.id)
    }
  }), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'relatorios-gerencial'
      },
      "label": "Relatórios Gerenciais",
      "icon": "fa-file-excel-o",
      "icon-color-class": "text-success",
      "show": _vm.ACL.check('acesso_menu_relatorios_gerenciais', _vm.currentUser.id) && !_vm.ACL.check('coordES', _vm.currentUser.id)
    }
  }), _vm._v(" "), (!_vm.ACL.check('coordES', _vm.currentUser.id)) ? _c('MenuRelatorios') : _vm._e(), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id) && (_vm.ACL.check('exibir_logs', _vm.currentUser.id) && !_vm.ACL.check('coordES', _vm.currentUser.id) || _vm.ACL.check('exibir_tasks', _vm.currentUser.id))) ? _c('MenuLogs') : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "line dk hidden-folded"
  }), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id) && _vm.ACL.check('gerenciar_usuario_intranet', _vm.currentUser.id)) ? _c('menu-title', [_vm._v("Colaborativo")]) : _vm._e(), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'usuarios'
      },
      "label": "Usuários",
      "icon": "icon-user",
      "icon-color-class": "text-success-lter",
      "show": _vm.ACL.check('restrito_visitante', _vm.currentUser.id) && _vm.ACL.check('gerenciar_usuario_intranet', _vm.currentUser.id)
    }
  }), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'usuarios',
        query: {
          somenteConsultaReboque: true
        }
      },
      "label": "Usuários Consulta Reboque",
      "icon": "icon-user",
      "icon-color-class": "text-info",
      "show": _vm.ACL.check('restrito_visitante', _vm.currentUser.id) && _vm.ACL.check('gerenciar_usuario_intranet', _vm.currentUser.id)
    }
  }), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'historico.alteracoes'
      },
      "label": "Histórico de alterações sistema",
      "icon": "fa-history",
      "icon-color-class": "text-danger-dker",
      "show": _vm.ACL.check('restrito_visitante', _vm.currentUser.id) && _vm.ACL.check('visualizar_log_alteracoes_usuarios', _vm.currentUser.id)
    }
  }), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('menu-title', [_vm._v("Estatísticas")]) : _vm._e(), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('MenuBI') : _vm._e(), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'relatorios-basico'
      },
      "label": "Relatórios Básicos",
      "icon": "icon-list",
      "show": _vm.ACL.check('restrito_visitante', _vm.currentUser.id)
    }
  }), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('menu-title', [_vm._v("Comunicação e Marketing")]) : _vm._e(), _vm._v(" "), _c('menu-item', {
    attrs: {
      "to": {
        name: 'contatos'
      },
      "label": "Contatos",
      "icon": "glyphicon-envelope",
      "icon-color-class": "text-info-lter",
      "icon-type": "glyphicon",
      "show": _vm.ACL.check('restrito_visitante', _vm.currentUser.id)
    }
  }), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('li', [_c('a', {
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.$parent.toggleChat()
      }
    }
  }, [_c('i', {
    staticClass: "icon-bubbles icon text-info"
  }), _vm._v(" "), _c('span', [_vm._v("Chat")])])]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://m.rebocarleiloes.com.br",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-location-arrow icon text-primary"
  }), _vm._v(" "), _c('span', [_vm._v("Automação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper m-t hidden"
  }, [_c('div', {
    staticClass: "text-center-folded"
  }, [_c('span', {
    staticClass: "pull-right pull-none-folded"
  }, [_vm._v("50%")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-folded"
  }, [_vm._v("Metas do mês")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xxs m-t-sm dk"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-info",
    staticStyle: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center-folded"
  }, [_c('span', {
    staticClass: "pull-right pull-none-folded"
  }, [_vm._v("50%")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-folded"
  }, [_vm._v("Metas do dia")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xxs m-t-sm dk"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    staticStyle: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center-folded"
  }, [_c('span', {
    staticClass: "pull-right pull-none-folded"
  }, [_vm._v("50%")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-folded"
  }, [_vm._v("Leitura dos avisos")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xxs m-t-sm dk"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-danger",
    staticStyle: {
      "width": "50%"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9cdff94","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/Menu.vue
// module id = 1852
// module chunks = 17